module.exports = __webpack_public_path__ + "static/media/What Asha Reads.6f8b809a.png";